import React, { useState, useEffect } from 'react';
import { SyncOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

const SyncStatusIndicator = () => {
    const [syncStatus, setSyncStatus] = useState({
        isVisible: false,
        message: '',
        isComplete: false
    });

    useEffect(() => {
        const handleSyncStatus = (event) => {
            const { message, isComplete } = event.detail;

            setSyncStatus({
                isVisible: true,
                message,
                isComplete
            });

            // Si la sincronización se completó, ocultar después de 5 segundos para dar tiempo a leer
            if (isComplete) {
                setTimeout(() => {
                    setSyncStatus(prev => ({ ...prev, isVisible: false }));
                }, 5000);
            }
        };

        window.addEventListener('syncStatus', handleSyncStatus);

        return () => {
            window.removeEventListener('syncStatus', handleSyncStatus);
        };
    }, []);

    if (!syncStatus.isVisible) {
        return null;
    }

    // Determinar el tipo de mensaje para mostrar el icono y color apropiados
    const isError = syncStatus.message.includes('Error');
    const isRetrying = syncStatus.message.includes('Reintentando');
    const isCompleted = syncStatus.isComplete && !isError;

    const getBackgroundColor = () => {
        if (isError) return '#ff4d4f';
        if (isCompleted) return '#52c41a';
        if (isRetrying) return '#faad14';
        return '#1677ff';
    };

    const getIcon = () => {
        if (isError) return <ExclamationCircleOutlined style={{ fontSize: '14px' }} />;
        if (isCompleted) return <CheckCircleOutlined style={{ fontSize: '14px' }} />;
        return <SyncOutlined spin style={{ fontSize: '14px' }} />;
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                backgroundColor: getBackgroundColor(),
                color: 'white',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                zIndex: 1001,
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                maxWidth: '400px',
                minWidth: '200px',
                wordBreak: 'break-word',
                animation: 'slideIn 0.3s ease-out',
                border: isError ? '1px solid #d9534f' : 'none'
            }}
        >
            {getIcon()}
            <span style={{ lineHeight: '1.4' }}>{syncStatus.message}</span>
        </div>
    );
};

export default SyncStatusIndicator; 